import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, timer, TimeoutError } from 'rxjs';
import { catchError, retry, timeout } from 'rxjs/operators';
import { Router } from '@angular/router';

// Errores de infraestructura: red caída, gateway, sobrecarga — seguros para reintentar
const RETRIABLE_STATUSES = new Set([0, 408, 502, 503, 504]);
const MAX_RETRIES = 3;
const REQUEST_TIMEOUT_MS = 30_000;

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private router: Router) {}

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        let request = req;

        if (localStorage.getItem('token')) {
            request = req.clone({
                setHeaders: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'Accept': 'application/json'
                }
            });
        }

        return next.handle(request).pipe(
            timeout(REQUEST_TIMEOUT_MS),
            retry({
                count: MAX_RETRIES,
                delay: (error, retryCount) => {
                    const isTimeout = error instanceof TimeoutError;
                    const isNetworkDown = error instanceof HttpErrorResponse && error.status === 0;
                    const isInfraError = error instanceof HttpErrorResponse && RETRIABLE_STATUSES.has(error.status);
                    // Para 500 solo reintentamos GETs (evitar POSTs duplicados)
                    const isServerError = error instanceof HttpErrorResponse
                        && error.status === 500
                        && request.method === 'GET';

                    if (!isTimeout && !isNetworkDown && !isInfraError && !isServerError) {
                        throw error;
                    }

                    // Backoff: 1 s → 2 s → 3 s
                    return timer(retryCount * 1000);
                }
            }),
            catchError((err) => {
                if (err instanceof HttpErrorResponse && err.status === 401) {
                    this.router.navigateByUrl('/login');
                }
                return throwError(err);
            })
        );
    }
}
